import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { compose, mapProps } from 'recompose';
import { withAnalytic } from '@skooldio/analytics-provider/dist/Analytics/hoc';
import styled from 'styled-components';
import { Redirect } from 'react-router';

import { Text, Box, Flex, Icon, ICON_LIST } from 'Components/Base';
import ButtonOutlinedIcon from 'Components/ButtonOutlinedIcon';
import { AdaptiveQuizAttemptExporter } from 'Containers/AdaptiveQuizExporter';
import AdaptiveQuizIndividual from 'Containers/AdaptiveQuizIndividual';
import { getAdaptiveQuizIndividualFilterValue } from 'Containers/AdaptiveQuiz/utils';
import { getStudentDisplayName, getUpdateTime } from 'Domains/adaptiveQuiz';
import { getSchoolCode } from 'Domains/LESchoolData/Routing';
import { useAnalytics } from 'Libs/Analytics';

const AdaptiveQuizIndividualPageWrapper = styled(Box)`
  border-radius: 10px;
  flex: 1 0;
  display: grid;
  grid: auto auto 1fr / 100%;
  row-gap: 16px;
`;

const AdaptiveQuizIndividualPage = ({
  schoolCode,
  username,
  onLogAction,
  history,
  location,
  auth: { myProfile },
}) => {
  const { send } = useAnalytics();
  const { t } = useTranslation('adaptiveQuiz');
  const [isFetchData, setIsFetchData] = useState(false);
  const [disabledFetch, setDisabledFetch] = useState(true);
  const [report, setReport] = useState(null);

  const filterValue = getAdaptiveQuizIndividualFilterValue(new URLSearchParams(location?.search));
  const backPath = `/report/${schoolCode}/adaptive-quiz${location?.search}`;

  if (
    !username ||
    !filterValue.term ||
    !filterValue.grade ||
    !filterValue.classNo ||
    !filterValue.subject ||
    !filterValue.syllabus
  ) {
    return <Redirect to={backPath} />;
  }

  const displayName = report ? getStudentDisplayName(report) : '';

  return (
    <AdaptiveQuizIndividualPageWrapper px={[0, null, 2, 7]} py={[0, null, 3, 5]} bg={'white'}>
      <Box>
        <Text.Title
          fontSize={4}
          color="primary"
          mb={5}
          onClick={() => history.push(backPath)}
          style={{ cursor: 'pointer' }}
        >
          <Flex alignItems="flex-end">
            <Icon mr={2} name={ICON_LIST.BACK} />
            {t('BACK')}
          </Flex>
        </Text.Title>
        <Flex alignItems={'center'} justifyContent={'space-between'}>
          {displayName ? <Text.Title>{displayName}</Text.Title> : <Box />}
          <Flex>
            <AdaptiveQuizAttemptExporter
              disabled={disabledFetch}
              filterValue={filterValue}
              schoolCode={schoolCode}
              username={username}
              myProfileId={myProfile.id}
            />
            <ButtonOutlinedIcon
              textProp={{
                fontWeight: 'semibold',
              }}
              ml={2}
              lineHeight={'0.5'}
              height={'40px'}
              leftIcon={<Icon name={ICON_LIST.REFRESH} />}
              message={t('UPDATE')}
              disabled={disabledFetch}
              onClick={() => {
                onLogAction({
                  category: 'Fatch data',
                  action: `Click`,
                  label: `Click on adaptive quiz individual page`,
                });
                send('update', { on: 'adaptive_quiz_individual_page' });
                setIsFetchData(true);
              }}
            />
          </Flex>
        </Flex>
        <Flex justifyContent={'flex-end'} height={'16px'}>
          <Text.Hint
            mt={1}
            color={'timeUpdate'}
            textAlign={'right'}
            display={disabledFetch ? 'none' : 'block'}
          >
            {t('UPDATE_DESCRIPTION_TIME')} {getUpdateTime()}
          </Text.Hint>
        </Flex>
      </Box>

      <AdaptiveQuizIndividual
        isFetchData={isFetchData}
        setIsFetchData={setIsFetchData}
        setDisabledFetch={setDisabledFetch}
        onReportLoaded={setReport}
        schoolCode={schoolCode}
        username={username}
      />
    </AdaptiveQuizIndividualPageWrapper>
  );
};

export default compose(mapProps(getSchoolCode), withAnalytic)(AdaptiveQuizIndividualPage);
